import { Mapping } from 'api/MappingsAPI';
import { CatalogMapping } from 'modules/domains';

/**
 * Converts a mapping from the mappings API to the data shape that Catalogs uses for field mappings
 */
export const getCatalogFieldMapping = (mappingApiEntry: Mapping): CatalogMapping => ({
  name: mappingApiEntry.fieldName,
  type: mappingApiEntry.fieldType,
});
